import {
	getLocalStorageItemAsString,
	setLocalStorageItem,
} from '@atlassian/search-common/local-storage';

import { logger } from '../logger';

const PREFIX = '@atlassian.search-ai.';

const setString = (key: string, value: string): void => {
	try {
		setLocalStorageItem(`${PREFIX}${key}`, value);
	} catch (error) {
		logger.error({
			feature: 'sain-text-answer',
			element: 'container',
			operation: 'persist',
			category: 'invariant',
			error,
			functionName: 'setString',
		});
	}
};

const getString = (key: string): string | null => {
	return getLocalStorageItemAsString(`${PREFIX}${key}`);
};

export const localStore: {
	getString: (key: string) => string | null;
	setString: (key: string, value: string) => void;
} = {
	getString,
	setString,
};
